export const realtimeTypes = {
  RealtimeService: Symbol.for('RealtimeService'),

  PusherAppKey: Symbol.for('PusherAppKey'),
  PusherHost: Symbol.for('PusherHost'),
  PusherMasterKey: Symbol.for('PusherMasterKey'),
}
